import ReactDOM from 'react-dom/client';
import { App } from './App.tsx';

// After a deployment the hashed chunks referenced by an already opened page no longer exist.
// Reload once to get the new index.html; the timestamp guard prevents a reload loop (e.g. when offline).
const preloadErrorReloadKey = 'vite-preload-error-reload';
window.addEventListener('vite:preloadError', (event) => {
    try {
        const lastReload = Number(sessionStorage.getItem(preloadErrorReloadKey) || 0);
        if (Date.now() - lastReload < 10000) {
            return;
        }
        sessionStorage.setItem(preloadErrorReloadKey, String(Date.now()));
    } catch {
        return;
    }

    event.preventDefault();
    window.location.reload();
});

ReactDOM.createRoot(document.getElementById('react-app')!).render(<App />);
